/**
 * External dependencies
 */
import { Component } from 'react'
import classnames from 'classnames'

import { range } from '~bookwormgb/util/range'

class ProductsCategoriesPlaceholder extends Component {

	render() {
		const {
			style= 'style-v1',
			mdColumns = 2,
			lgColumns = 3,
			xlColumns = 4,
			wdColumns = 5,
			limit = 4,
			placeholder = 0,
			showCategoryIcon = true,
			showProductCategoryTitle = true,
			showProductCategoryList = true,
			showShopNow = true,
		} = this.props

		let output = ''

		switch ( style ) {
			case 'style-v1':
				output = (
					<ul className={ classnames( [
						'products-categories-placeholder',
						'products-categories',
						'list-unstyled',
						'my-0',
						'row', 
						`row-cols-md-${mdColumns}`,
						`row-cols-lg-${lgColumns}`,
						`row-cols-xl-${xlColumns}`,
						`row-cols-wd-${wdColumns}`,
					], {} ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<li className="product-category col mb-5" key={ `product-${i}` }>
									<div className="product-category__inner bg-light px-6 py-5">
										{ showCategoryIcon &&
											<div className="rounded-circle mb-2" style={ { 
												height:'100px', width: '100px', 'backgroundColor': '#ffffff', 'marginBottom': '10px' 
											} }></div>
										}
										<div className="d-block">
											<div className="product-category__body">
												{ showProductCategoryTitle &&
													<div className="badge badge-shadow w-100 d-block">
														<div className="progress bg-white"></div>
													</div>
												}
												{ showShopNow &&
													<div className="badge badge-shadow w-100 d-block">
														<div className="progress bg-white"></div>
													</div>
												}
											</div>
										</div>
									</div>
								</li>
							)
						} ) }
					</ul>
				)
			break

			case 'style-v2':
				output = (
					<ul className={ classnames( [
						'products-categories-placeholder',
						'products-categories',
						'list-unstyled',
						'my-0',
						'row', 
						`row-cols-md-${mdColumns}`,
						`row-cols-lg-${lgColumns}`,
						`row-cols-xl-${xlColumns}`,
						'flex-nowrap',
						'overflow-hidden',
					], {} ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<li className="product-category col mb-5" key={ `product-${i}` }>
									<div className="product-category__inner px-6 py-5">
										{ showCategoryIcon &&
											<div className="d-flex justify-content-center">
												<div className="rounded-circle mb-2" style={ { 
													height:'50px', width: '50px', 'backgroundColor': '#f8f9fa', 'marginBottom': '10px'
												} }></div>
											</div>
										}
										<div className="d-block">
											<div className="product-category__body">
												{ showProductCategoryTitle &&
													<div className="badge badge-shadow w-100 d-block">
														<div className="progress bg-light"></div>
													</div>
												}
											</div>
										</div>
									</div>
								</li>
							)
						} ) }
					</ul>
				)
			break

			case 'style-v3':
				output = (
					<ul className={ classnames( [
						'products-categories-placeholder',
						'products-categories',
						'list-unstyled',
						'my-0',
						'row', 
						`row-cols-md-${mdColumns}`,
						`row-cols-lg-${lgColumns}`,
						`row-cols-xl-${xlColumns}`,
						`row-cols-wd-${wdColumns}`,
					], {} ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<li className="product-category col mb-5" key={ `product-${i}` }>
									<div className="product-category__inner px-6 py-5">
										<div className="d-block">
											<div className="product-category__body">
												{ showProductCategoryTitle &&
													<div className="badge badge-shadow w-100 d-block mb-4">
														<div className="progress bg-light"></div>
													</div>
												}
												{ showProductCategoryList &&
													<div className="badge badge-shadow w-80 d-block mb-2">
														<div className="progress bg-light"></div>
													</div>
												}
												{ showProductCategoryList &&
													<div className="badge badge-shadow w-80 d-block mb-2">
														<div className="progress bg-light"></div>
													</div>
												}
												{ showProductCategoryList &&
													<div className="badge badge-shadow w-80 d-block mb-2">
														<div className="progress bg-light"></div>
													</div>
												}
												{ showProductCategoryList &&
													<div className="badge badge-shadow w-80 d-block mb-2">
														<div className="progress bg-light"></div>
													</div>
												}
												{ showProductCategoryList &&
													<div className="badge badge-shadow w-80 d-block mb-2">
														<div className="progress bg-light"></div>
													</div>
												}
												{ showProductCategoryList &&
													<div className="badge badge-shadow w-80 d-block mb-2">
														<div className="progress bg-light"></div>
													</div>
												}

												{ showCategoryIcon &&
													<div className="d-flex justify-content-end">
														<div className="rounded-circle mb-2" style={ { 
															height:'50px', width: '50px', 'backgroundColor': '#f8f9fa', 'marginBottom': '10px' 
														} }></div>
													</div>
												}
											</div>
										</div>
									</div>
								</li>
							)
						} ) }
					</ul>
				)
			break

			case 'style-v4':
				output = (
					<div className={ classnames( [
						'products-categories-placeholder',
						'products-categories',
						'list-unstyled',
						'my-0',
						'row',
						'flex-nowrap',
						'flex-md-wrap',
						'overflow-auto',
						'row-cols-1',
						`row-cols-md-${mdColumns}`,
						`row-cols-lg-${lgColumns}`,
						`row-cols-xl-${xlColumns}`,
						`row-cols-wd-${wdColumns}`,
					], {} ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<div className="product-category col mb-5" key={ `product-${i}` }>
									<div className="product-category__inner px-6 py-5">
										{ showCategoryIcon &&
											<div className="d-flex justify-content-center">
												<div className="rounded-circle mb-2" style={ { 
													height:'100px', width: '100px', 'backgroundColor': '#f8f9fa', 'marginBottom': '10px' 
												} }></div>
											</div>
										}
										<div className="d-block">
											<div className="product-category__body">
												{ showProductCategoryTitle &&
													<div className="badge badge-shadow w-100 d-block">
														<div className="progress bg-light"></div>
													</div>
												}
											</div>
										</div>
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break
		}

		return output
	}
}

export default ProductsCategoriesPlaceholder